import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IAuditorRepository } from "../../repositories/auditor_repository";
import { AuditoriasLista } from "../../models/auditorias_lista";
import { AuditoriasListaFilter } from "../../models/auditor_auditorias_filter";
import { IGetAllAuditorAuditoriasUseCase } from "../../../presentation/useCases/read/get_all_auditor_auditorias_use_case";


// GetAllAuditoriasAuditoriasServicoUseCase


export class GetAllAuditoriasAuditoriasServicoUseCase
  extends BasePaginatedUseCase<AuditoriasLista>
  implements IGetAllAuditorAuditoriasUseCase {
  constructor(private readonly repository: IAuditorRepository) {
    super();
  }

  async getAllListagemAuditoria(
    filter: AuditoriasListaFilter,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    if (filter.IdAuditoria === undefined) throw new Error('Id de auditoria invalido!');

    const response = await this.repository
      .getAllListagemAuditoria(
        filter,
        page,
        rowsPerPage,
      );
    
    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
